import { useEffect } from 'react';

export function useReveal() {
  useEffect(() => {
    const ro = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('vis'); });
    }, { threshold: 0.08 });
    const els = document.querySelectorAll('.rev, .rev-l, .rev-r');
    els.forEach(el => ro.observe(el));
    return () => ro.disconnect();
  }, []);
}

export function useFloatBtn() {
  useEffect(() => {
    const btn = document.getElementById('floatBtn');
    if (!btn) return;
    const onScroll = () => btn.classList.toggle('show', window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
}

export function useCounter(sectionId) {
  useEffect(() => {
    function counter(el, target, suffix) {
      const dur = 1800, t0 = performance.now();
      const tick = now => {
        const p = Math.min((now - t0) / dur, 1);
        const v = Math.floor((1 - Math.pow(1 - p, 3)) * target);
        el.textContent = v + suffix;
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }
    const section = document.getElementById(sectionId);
    if (!section) return;
    const so = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          document.querySelectorAll('.stat-num, .ss-num').forEach(el => {
            const t = +el.dataset.t;
            counter(el, t, t === 100 ? '%' : '+');
            const item = el.closest('.stat-item, .ss-item');
            if (item) item.classList.add('vis');
          });
          so.disconnect();
        }
      });
    }, { threshold: 0.3 });
    so.observe(section);
    return () => so.disconnect();
  }, [sectionId]);
}
